import HTMLImg from './html_img'
export default HTMLImg
